<template>
<v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">{{ GetEjecucion }}
   <h1>DGII:Facturación Electrónica</h1> 

   <v-snackbar v-model="aalert.estado" :color="aalert.color" style="margin-top: 20%;" :vertical="true"
      :timeout="aalert.timeout" :right="aalert.right" :top="aalert.top">
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
   </v-snackbar>
</v-col>

</template>
<script>
import { EventBus } from "@/event-bus";
import { currencyFormatter, FormatoFecha, HoraFormatter,RedondeoValorCantRed,currencyFormatterCant,RedondeoValor,RedondeoBasico,fechaNueva,getHoraActual,getParamFecha } from "@/js/Funciones.js";
import VueAutonumeric from "../../components/AutoNumericNuevo";
export default {
  components: {
    VueAutonumeric
  },
  created() { 
            console.log('created--PVCONFIGU')
  },
  mounted() {
 

  },
  beforeDestroy() {

  },

  data: () => ({  
    //  testecf ,certecf, ecf 
     ambiente:'testecf',
     semilla:null,
     arrayPropiedases: {
      'items-per-page-options': [10, 15, 20, 50],
      'items-per-page-text': 'Cantidad de Registros Por Paginas',
      showFirstLastPage: false
    },
    windowSize: { width: "auto", height: "auto" },
    valid: true,
    aalert: {
      estado: false,
      color: null,
      timeout: 3000,
      top: false,
      right: false
      },
    

  }),

  methods: { 
    currencyFormatter, FormatoFecha, HoraFormatter,RedondeoValorCantRed,currencyFormatterCant,RedondeoValor,
    RedondeoBasico,fechaNueva,getHoraActual,getParamFecha,
   
   
    async getAprovacion(){

  //var AMBIENTE='testecf'
  var AMBIENTE= this.ambiente
  var HEADER={'Content-Type': "application/json" }
  var url1=`https://eCF.dgii.gov.do/${AMBIENTE}/aprobacioncomercia`

  return  new Promise((resolve, reject) => {
    this.$axios.get(url1, 
          { headers: HEADER })
        .then((res) => {
          console.log(res.data)
          (async () => {  

            var AMBIENTE= this.ambiente
    let texto = res.data
  let blob = new Blob([texto], { type: 'application/xml' });
  const formData = new FormData();  
  formData.append('xml', blob, 'data.xml');   

            resolve(res.data)
         /* const resXMLsellado =  await this.firmarArchivoXML(res.data);
          const resXMLvalidado =  await this.varlidarSemilla(resXMLsellado);
        //  return resXMLvalidado;
            resolve(resXMLvalidado)*/
          })()
      // 
          })
          .catch((error) => console.log(error));

   });
 


},
   
   
   
    async getSemillaValidaGetToken(FACTURA){
  var ObjDirecSucursal={
nombreCertDGI:FACTURA.caja.sucursal.nombreArchivoDgi,
passCertDGI:FACTURA.caja.sucursal.passCertDgi,
sucursalRnc:FACTURA.caja.sucursal.rnc.trim().replace("-", "").replace(/-/g,'')
 }
  //var AMBIENTE='testecf'FACTURA
  // var AMBIENTE= this.ambiente
  var AMBIENTE=FACTURA.sucursal.ambienteDgi!=null?FACTURA.sucursal.ambienteDgi:"testecf";
  var HEADER={'Content-Type': "application/json" }
  var url1=`https://eCF.dgii.gov.do/${AMBIENTE}/autenticacion/api/autenticacion/semilla`

  return  new Promise((resolve, reject) => {
    this.$axios.get(url1, 
          { headers: HEADER })
        .then((res) => {
          (async () => {  
          const resXMLsellado =  await this.firmarArchivoXML(res.data,ObjDirecSucursal);
          const resXMLvalidado =  await this.varlidarSemilla(resXMLsellado,FACTURA);
        //  return resXMLvalidado;
            resolve(resXMLvalidado)
          })()
      // 
          })
          .catch((error) => console.log(error));

   });
 


},


async firmarArchivoXML(XMLSTRING,ObjDirecSucursal){
  var HEADER={'Content-Type': "application/json" }
 return  new Promise((resolve, reject) => {  
  var Obj={
    XMLSTRING:XMLSTRING,
    nombreCertDGI:ObjDirecSucursal.nombreCertDGI,
    passCertDGI:ObjDirecSucursal.passCertDGI,
    sucursalRnc:ObjDirecSucursal.sucursalRnc
  }

  // + "/importData/pruebafimaDgi",XMLSTRING
  this.$axios
        .post(this.$hostname + this.$hName + "/importData/pruebafimaDgi",Obj , { headers: HEADER })
        .then(res1 => {
         // return res1.data
          resolve(res1.data)
        })
        .catch((error) => {
          this.alerta("sello no generado", "error")
          //return null;
          resolve(null)
        });
});

},



async varlidarSemilla(XML,FACT){

  return  new Promise((resolve, reject) => {  
    //var AMBIENTE='testecf'
   // var AMBIENTE= this.ambiente
   var AMBIENTE=FACT.sucursal.ambienteDgi!=null?FACT.sucursal.ambienteDgi:"testecf";
    let texto = XML
  let blob = new Blob([texto], { type: 'application/xml' });
  const formData = new FormData();  
  formData.append('xml', blob, 'data.xml');      
        var headHEAD={} ;
         headHEAD["Content-Type"] = "multipart/form-data"
         headHEAD["accept"]= "application/json"
         var url2=`https://ecf.dgii.gov.do/${AMBIENTE}/autenticacion/api/Autenticacion/ValidarSemilla`
          this.$axios.post(url2,formData,{ headers: headHEAD })
        .then((resss) => {
          var TOKEN_SUC=resss.data
          TOKEN_SUC.sucursal=FACT.sucursal.codigo
          this.actualizarToken(TOKEN_SUC)
          this.semilla=resss.data;
          resolve(resss.data)
         })
         .catch((error) => {
          this.alerta("DATA XML NO VALIDADO", "error")
          resolve(null)
        });

  });
},

actualizarToken(TOKEN_SUC){
  this.$axios.post(this.$hostname + this.$hName + "/sucursal/actualizartoken",
  TOKEN_SUC,{ headers: this.$store.getters.GetheadersAxios })
            .then((res) => {
              console.log("actualizartoken guardado correctamente-->",res.data)
            })
            .catch((error) => {
              console.log("actualizartoken no guardado correctamente-->",error)
            });
  //sucursal/actualizartoken
},

getEmisorFactEletroECF(FACTURA){
// var RNCEmisor = this.$store.getters.GetConfiguracionGeneral.config.rnc.trim().replace("-", "").replace(/-/g,'');
var RNCEmisor =FACTURA.sucursal.rnc.trim().replace("-", "").replace(/-/g,'');
//var SocialEmisor=this.$store.getters.GetConfiguracionGeneral.config.nombre.trim();
var SocialEmisor=FACTURA.sucursal.descripcion.trim()
var FechaEmision=this.FormatoFecha(FACTURA.nuevaFecha);
var Correo = this.$store.getters.GetConfiguracionGeneral.config.email.trim();
var TelefonoEmisor = FACTURA.sucursal.telefono.trim().replace("(", "").replace(")", "-");
 
// console.log('FACsuc-->',FACTURA.sucursal.telefono.trim())
// console.log('TelefonoEmisor-->',TelefonoEmisor)
// 

// <Sucursal>${FACTURA.sucursal.descripcion.trim()}</Sucursal>
var EMISOR=`
    <Emisor>
      <RNCEmisor>${RNCEmisor}</RNCEmisor>
      <RazonSocialEmisor>${SocialEmisor}</RazonSocialEmisor>
      <NombreComercial>${SocialEmisor}</NombreComercial>
      <DireccionEmisor>${FACTURA.sucursal.direccion.trim()}</DireccionEmisor>
        <TablaTelefonoEmisor>
         <TelefonoEmisor>${TelefonoEmisor}</TelefonoEmisor>
        </TablaTelefonoEmisor>
      <CorreoEmisor>${Correo}</CorreoEmisor> 
      <FechaEmision>${FechaEmision}</FechaEmision>
    </Emisor>`
    return EMISOR;

},

getCompradorFactEletroECF_RFCE(FACTURA){
  var SocialComprador= FACTURA.nombreDgii.trim().length==0?'CONTADO':FACTURA.nombreDgii.trim().toUpperCase()
  var RNCComprador= FACTURA.cedularncncf.trim().replace("-", "").replace(/-/g,'');
 var COMPRADOR=""
 if(RNCComprador.trim().length>0){
  COMPRADOR=`
    <Comprador>
      <RNCComprador>${RNCComprador}</RNCComprador>
      <RazonSocialComprador>${SocialComprador}</RazonSocialComprador>
    </Comprador>`
 }
 
    return COMPRADOR;

},
getTotalFactEletroECF(FACTURA){
  var TipoeCF= FACTURA.tipocomprobante.hasOwnProperty('tipoEcf') && FACTURA.tipocomprobante.tipoEcf!=null?FACTURA.tipocomprobante.tipoEcf:'';
  // MontoGravadoTotal:total de todos los itbis
  var IncluirItbisGeneral =this.$store.getters.GetConfiguracionGeneral.configPv.impuestoincluido;
  var MontoTotal= this.RedondeoValorCantRed(FACTURA.valor,2);
  var TotalItbis= this.RedondeoValorCantRed(FACTURA.valorimpuesto,2);
  var TOTALXML=''

  var MontoGravadoTotal=0.00
  //var ITBIS18=FACTURA.valorimpuesto!=null ? JSON.parse(JSON.stringify(this.RedondeoValorCantRed(FACTURA.valorimpuesto,2))):0
  var ITBIS18=0.00;
  var ITBIS16=0.00; 
  var ITBIS0=0.00;
  var valorMontoExento=0.00;
  var MontoExento='';
  var ValorPagar='';

var ListDet= FACTURA.ListDet.filter((ee) => ee.impuesto ==null);
Promise.all(ListDet.map(async (element) => {
  valorMontoExento+= (this.RedondeoValorCantRed((element.cantidad*element.precio),2))
 }));

 var MontoGravadoI1=0.00;
 var MontoGravadoI2=0.00;
 var MontoGravadoI3=0.00;
 Promise.all(FACTURA.ListDet.filter((ee) => ee.impuesto !=null && ee.impuesto.hasOwnProperty("tasa")).map(async (element) => {

    if(element.impuesto.tasa==18){
      MontoGravadoI1+=(this.RedondeoValorCantRed((element.cantidad*element.precio),2))
      ITBIS18+=(element.valorimpuesto*element.cantidad)
    }
    if(element.impuesto.tasa==16){
       MontoGravadoI2+=(this.RedondeoValorCantRed((element.cantidad*element.precio),2))
      ITBIS16+=(element.valorimpuesto*element.cantidad)
    }
    if(element.impuesto.tasa==0){
       MontoGravadoI3+=(this.RedondeoValorCantRed((element.cantidad*element.precio),2))
       ITBIS0+=(element.valorimpuesto*element.cantidad)
    }
 }));

 MontoGravadoI1=(MontoGravadoI1-ITBIS18);
 MontoGravadoI2=(MontoGravadoI2-ITBIS16);
 MontoGravadoI3=(MontoGravadoI3-ITBIS0);

  if(TotalItbis>0){
  if(IncluirItbisGeneral==false){
    // TOTALXML+=`<MontoGravadoTotal>${  this.RedondeoValorCantRed(MontoTotal-TotalItbis,2)  }</MontoGravadoTotal>`
    // if(ITBIS18>0){TOTALXML+=`<MontoGravadoI1>${this.RedondeoValorCantRed(MontoTotal-TotalItbis,2)}</MontoGravadoI1>`}
   
     TOTALXML+=`<MontoGravadoTotal>${this.RedondeoValorCantRed((MontoGravadoI1+MontoGravadoI2+MontoGravadoI3),2)}</MontoGravadoTotal>`
     if(ITBIS18>0){TOTALXML+=`<MontoGravadoI1>${this.RedondeoValorCantRed(MontoGravadoI1,2)}</MontoGravadoI1>`}
    if(ITBIS16>0){TOTALXML+=`<MontoGravadoI2>${this.RedondeoValorCantRed(MontoGravadoI2,2)}</MontoGravadoI2>`}
    if(ITBIS0>0){TOTALXML+=`<MontoGravadoI3>${this.RedondeoValorCantRed(MontoGravadoI3,2)}</MontoGravadoI3>`}

    if(ITBIS18>0){TOTALXML+=`<ITBIS1>18</ITBIS1>`}
    if(ITBIS16>0){TOTALXML+=`<ITBIS2>16</ITBIS2>`}
    if(ITBIS0>0){TOTALXML+=`<ITBIS3>0</ITBIS3>`}

    TOTALXML+=`<TotalITBIS>${this.RedondeoValorCantRed(ITBIS18+ITBIS16+ITBIS0,2)}</TotalITBIS>`

    if(ITBIS18>0){TOTALXML+=`<TotalITBIS1>${this.RedondeoValorCantRed(ITBIS18,2)}</TotalITBIS1>`}
    if(ITBIS16>0){TOTALXML+=`<TotalITBIS2>${this.RedondeoValorCantRed(ITBIS16,2)}</TotalITBIS2>`}
    if(ITBIS0>0){TOTALXML+=`<TotalITBIS3>${this.RedondeoValorCantRed(ITBIS0,2)}</TotalITBIS3>`}
  }else{
    //TOTALXML+=`<MontoGravadoTotal>${this.RedondeoValorCantRed(MontoTotal-TotalItbis,2)}</MontoGravadoTotal>`
   // if(ITBIS18>0){TOTALXML+=`<MontoGravadoI1>${this.RedondeoValorCantRed(MontoTotal-TotalItbis,2)}</MontoGravadoI1>`}
   TOTALXML+=`<MontoGravadoTotal>${this.RedondeoValorCantRed((MontoGravadoI1+MontoGravadoI2+MontoGravadoI3),2)}</MontoGravadoTotal>`
   if(ITBIS18>0){TOTALXML+=`<MontoGravadoI1>${this.RedondeoValorCantRed(MontoGravadoI1,2)}</MontoGravadoI1>`}
   if(ITBIS16>0){TOTALXML+=`<MontoGravadoI2>${this.RedondeoValorCantRed(MontoGravadoI2,2)}</MontoGravadoI2>`}
    if(ITBIS0>0){TOTALXML+=`<MontoGravadoI3>${this.RedondeoValorCantRed(MontoGravadoI3,2)}</MontoGravadoI3>`}
    //-------------------------------------------------- 
    if(ITBIS18>0){TOTALXML+=`<ITBIS1>18</ITBIS1>`}
    if(ITBIS16>0){TOTALXML+=`<ITBIS2>16</ITBIS2>`}
    if(ITBIS0>0){TOTALXML+=`<ITBIS3>0</ITBIS3>`}
    //---------------------------------------------------- 
    TOTALXML+=`<TotalITBIS>${this.RedondeoValorCantRed(ITBIS18+ITBIS16+ITBIS0,2)}</TotalITBIS>`
//  if(ITBIS18>0){TOTALXML+=`<TotalITBIS1>${this.RedondeoValorCantRed(TotalItbis,2)}</TotalITBIS1>`}
    if(ITBIS18>0){TOTALXML+=`<TotalITBIS1>${this.RedondeoValorCantRed(ITBIS18,2)}</TotalITBIS1>`}
    if(ITBIS16>0){TOTALXML+=`<TotalITBIS2>${this.RedondeoValorCantRed(ITBIS16,2)}</TotalITBIS2>`}
    if(ITBIS0>0){TOTALXML+=`<TotalITBIS3>${this.RedondeoValorCantRed(ITBIS0,2)}</TotalITBIS3>`}
  }
}

// TOTALXML+=`<MontoTotal>${FACTURA.valor}</MontoTotal>`

if(TipoeCF==44){
  MontoExento=`
  <MontoExento>${MontoTotal}</MontoExento>
  `
  ValorPagar=`
  <ValorPagar>${MontoTotal}</ValorPagar>
  `
}else{
  if(valorMontoExento>0){
 MontoExento=`
  <MontoExento>${valorMontoExento}</MontoExento>
  `
  }

  
}


  var TOTAL=`
  <Totales>
       ${TOTALXML} ${MontoExento}
      <MontoTotal>${MontoTotal}</MontoTotal>${ValorPagar}
    </Totales>
  `
return TOTAL;

/* NOTAS:
<MontoGravadoTotal>350765.00</MontoGravadoTotal>
(<MontoGravadoI1>+<MontoGravadoI2>+<MontoGravadoI3>)
(269805.00+80190.00+770.00) = 350765
--
<MontoExento>1625.00</MontoExento>
--
<TotalITBIS>61395.30</TotalITBIS>
(<TotalITBIS1>+<TotalITBIS2>+<TotalITBIS3>)
(48564.90+12830.40+0.00)=61395.3
--
(<MontoGravadoTotal>+<TotalITBIS>+<MontoExento>)
(350765.00+61395.30+1625.00)=413785.3
<MontoTotal>413785.30</MontoTotal>
*/ 

},


getTotalFactEletroRFCE(FACTURA){
  // MontoGravadoTotal:total de todos los itbis
  var IncluirItbisGeneral =this.$store.getters.GetConfiguracionGeneral.configPv.impuestoincluido;
  var MontoTotal= this.RedondeoValorCantRed(FACTURA.valor,2);
  var TotalItbis= this.RedondeoValorCantRed(FACTURA.valorimpuesto,2);
  var TOTALXML=''

 
  var MontoGravadoTotal=0.00
  // var ITBIS18=FACTURA.valorimpuesto!=null ? JSON.parse(JSON.stringify(this.RedondeoValorCantRed(FACTURA.valorimpuesto,2))):0
  var ITBIS18=0.00;
  var ITBIS16=0.00; 
  var ITBIS0=0.00;
  var valorMontoExento=0.00;
  var MontoExento='';

  var ListDet= FACTURA.ListDet.filter((ee) => ee.impuesto ==null);
Promise.all(ListDet.map(async (element) => {
  valorMontoExento+= (this.RedondeoValorCantRed((element.cantidad*element.precio),2))
 }));

 var MontoGravadoI1=0.00;
 var MontoGravadoI2=0.00;
 var MontoGravadoI3=0.00;
 Promise.all(FACTURA.ListDet.filter((ee) => ee.impuesto !=null && ee.impuesto.hasOwnProperty("tasa")).map(async (element) => {

    if(element.impuesto.tasa==18){
      MontoGravadoI1+=(this.RedondeoValorCantRed((element.cantidad*element.precio),2))
      ITBIS18+=(element.valorimpuesto*element.cantidad)
    }
    if(element.impuesto.tasa==16){
       MontoGravadoI2+=(this.RedondeoValorCantRed((element.cantidad*element.precio),2))
      ITBIS16+=(element.valorimpuesto*element.cantidad)
    }
    if(element.impuesto.tasa==0){
       MontoGravadoI3+=(this.RedondeoValorCantRed((element.cantidad*element.precio),2))
       ITBIS0+=(element.valorimpuesto*element.cantidad)
    }
 }));

 MontoGravadoI1=(MontoGravadoI1-ITBIS18);
 MontoGravadoI2=(MontoGravadoI2-ITBIS16);
 MontoGravadoI3=(MontoGravadoI3-ITBIS0);

  if(TotalItbis>0){
  if(IncluirItbisGeneral==false){

    // TOTALXML+=`<MontoGravadoTotal>${FACTURA.valor-FACTURA.valorimpuesto}</MontoGravadoTotal>`
    TOTALXML+=`<MontoGravadoTotal>${this.RedondeoValorCantRed((MontoGravadoI1+MontoGravadoI2+MontoGravadoI3),2)}</MontoGravadoTotal>`
    if(ITBIS18>0){TOTALXML+=`<MontoGravadoI1>${this.RedondeoValorCantRed(MontoGravadoI1,2)}</MontoGravadoI1>`}
    if(ITBIS16>0){TOTALXML+=`<MontoGravadoI2>${this.RedondeoValorCantRed(MontoGravadoI2,2)}</MontoGravadoI2>`}
    if(ITBIS0>0){TOTALXML+=`<MontoGravadoI3>${this.RedondeoValorCantRed(MontoGravadoI3,2)}</MontoGravadoI3>`}
    
    TOTALXML+=`<TotalITBIS>${this.RedondeoValorCantRed(ITBIS18+ITBIS16+ITBIS0,2)}</TotalITBIS>`
    // if(ITBIS18>0){TOTALXML+=`<TotalITBIS1>${this.RedondeoValorCantRed(FACTURA.valorimpuesto,2)}</TotalITBIS1>`}
    if(ITBIS18>0){TOTALXML+=`<TotalITBIS1>${this.RedondeoValorCantRed(ITBIS18,2)}</TotalITBIS1>`}
    if(ITBIS16>0){TOTALXML+=`<TotalITBIS2>${this.RedondeoValorCantRed(ITBIS16,2)}</TotalITBIS2>`}
    if(ITBIS0>0){TOTALXML+=`<TotalITBIS3>${this.RedondeoValorCantRed(ITBIS0,2)}</TotalITBIS3>`}
  }else{

    // TOTALXML+=`<MontoGravadoTotal>${FACTURA.valor-FACTURA.valorimpuesto}</MontoGravadoTotal>`
   TOTALXML+=`<MontoGravadoTotal>${this.RedondeoValorCantRed((MontoGravadoI1+MontoGravadoI2+MontoGravadoI3),2)}</MontoGravadoTotal>`
    if(ITBIS18>0){TOTALXML+=`<MontoGravadoI1>${this.RedondeoValorCantRed(MontoGravadoI1,2)}</MontoGravadoI1>`}
    if(ITBIS16>0){TOTALXML+=`<MontoGravadoI2>${this.RedondeoValorCantRed(MontoGravadoI2,2)}</MontoGravadoI2>`}
    if(ITBIS0>0){TOTALXML+=`<MontoGravadoI3>${this.RedondeoValorCantRed(MontoGravadoI3,2)}</MontoGravadoI3>`}
    
    TOTALXML+=`<TotalITBIS>${this.RedondeoValorCantRed(ITBIS18+ITBIS16+ITBIS0,2)}</TotalITBIS>`
    if(ITBIS18>0){TOTALXML+=`<TotalITBIS1>${this.RedondeoValorCantRed(ITBIS18,2)}</TotalITBIS1>`}
    if(ITBIS16>0){TOTALXML+=`<TotalITBIS2>${this.RedondeoValorCantRed(ITBIS16,2)}</TotalITBIS2>`}
    if(ITBIS0>0){TOTALXML+=`<TotalITBIS3>${this.RedondeoValorCantRed(ITBIS0,2)}</TotalITBIS3>`}

  }
}

// TOTALXML+=`<MontoTotal>${FACTURA.valor}</MontoTotal>`
 if(valorMontoExento>0){
 MontoExento=`
  <MontoExento>${valorMontoExento}</MontoExento>
  `
  }
  var TOTAL=`
  <Totales>
       ${TOTALXML}  ${MontoExento}
      <MontoTotal>${MontoTotal}</MontoTotal>
    </Totales>
  `
return TOTAL;
},


getEmisorFactEletroRFCE(FACTURA){
//var RNCEmisor = this.$store.getters.GetConfiguracionGeneral.config.rnc.trim().replace("-", "").replace(/-/g,'');
var RNCEmisor =FACTURA.sucursal.rnc.trim().replace("-", "").replace(/-/g,'');
var SocialEmisor=this.$store.getters.GetConfiguracionGeneral.config.nombre.trim();
var FechaEmision=this.FormatoFecha(FACTURA.nuevaFecha);
  var EMISOR=`
    <Emisor>
      <RNCEmisor>${RNCEmisor}</RNCEmisor>
      <RazonSocialEmisor>${SocialEmisor}</RazonSocialEmisor>
      <FechaEmision>${FechaEmision}</FechaEmision>
    </Emisor>`
    return EMISOR;

},



getTipoIngresos(TipoeCF){
var TipoIngresos='';
// ${this.getTipoIngresos(TipoeCF)}

if(TipoeCF===41){
  TipoIngresos='';
}else{
TipoIngresos='<TipoIngresos>01</TipoIngresos>';
}
return TipoIngresos;
},

getFormaDePagoFACTELECT(FACTURA){
  var MONEDAFACTURATASA=1
var SumaTotal = this.RedondeoBasico((FACTURA.efectivo +FACTURA.tarjeta + FACTURA.transferencia + FACTURA.cheques + FACTURA.cxc
        + FACTURA.cupones + FACTURA.valorConduce + FACTURA.valorNc)*MONEDAFACTURATASA)
var DEVUELTA=0
if(SumaTotal>FACTURA.valor){DEVUELTA=(SumaTotal-FACTURA.valor)}    

//formas de pago
/* a) Código Forma: 1: Efectivo 2: Cheque/Transferencia/Depósito 3: Tarjeta de Débito/Crédito 
4: Venta a Crédito 5: Bonos o Certificados de regalo 6: Permuta 7: Nota de crédito 8: Otras Formas de pago.
Si la forma de pago corresponde al tipo 
5 el e-CF debe ser tipo 32. */

var FormaDePago='';
if(FACTURA.efectivo>0){
  FormaDePago+=`
        <FormaDePago>
         <FormaPago>1</FormaPago>
         <MontoPago>${FACTURA.efectivo-DEVUELTA}</MontoPago>
        </FormaDePago>`
}

if(FACTURA.cheques>0){
  FormaDePago+=`
        <FormaDePago>
         <FormaPago>2</FormaPago>
         <MontoPago>${FACTURA.cheques}</MontoPago>
        </FormaDePago>`
}

if(FACTURA.transferencia>0){
  FormaDePago+=`
        <FormaDePago>
         <FormaPago>2</FormaPago>
         <MontoPago>${FACTURA.transferencia}</MontoPago>
        </FormaDePago>`
}

if(FACTURA.tarjeta>0){
  FormaDePago+=`
        <FormaDePago>
         <FormaPago>3</FormaPago>
         <MontoPago>${FACTURA.tarjeta}</MontoPago>
        </FormaDePago>`
}

if(FACTURA.cxc>0){
  FormaDePago+=`
        <FormaDePago>
         <FormaPago>4</FormaPago>
         <MontoPago>${FACTURA.cxc}</MontoPago>
        </FormaDePago>`
}

if(FACTURA.cxc>0){
  FormaDePago+=`
        <FormaDePago>
         <FormaPago>4</FormaPago>
         <MontoPago>${FACTURA.cxc}</MontoPago>
        </FormaDePago>`
}

if(FACTURA.valorNc>0){
  FormaDePago+=`
        <FormaDePago>
         <FormaPago>7</FormaPago>
         <MontoPago>${FACTURA.valorNc}</MontoPago>
        </FormaDePago>`
}

if(FACTURA.cupones>0){
  FormaDePago+=`
        <FormaDePago>
         <FormaPago>5</FormaPago>
         <MontoPago>${FACTURA.cupones}</MontoPago>
        </FormaDePago>`
}
return FormaDePago;
},


getDetallesItems(FACTURA){
  var TipoeCF= FACTURA.tipocomprobante.hasOwnProperty('tipoEcf') && FACTURA.tipocomprobante.tipoEcf!=null?FACTURA.tipocomprobante.tipoEcf:'';
   // <IndicadorFacturacion>0</IndicadorFacturacion>
   //0: No Facturable 
  //1: ITBIS 1 (18%)  
  //2: ITBIS 2 (16%) 
  //3: ITBIS 3 (0%) 
  //4: Exento (E) 
  var ListDet=FACTURA.facturasventaDetalleList
  var VARDET=""
  var NumeroLinea=1


  // ListDet.forEach(element => { });
  Promise.all(ListDet.map(async (element) => {
    var IND_FACT=0

  //var MONTO_IMPUESTO=0;
  var MONTO_IMPUESTO=element.valorimpuesto;
  if(element.valorimpuesto>0 &&element.impuesto!=null && element.impuesto.hasOwnProperty("tasa")){
    if(element.impuesto.tasa==18){IND_FACT=1}
    if(element.impuesto.tasa==16){IND_FACT=2}
    if(element.impuesto.tasa==0){IND_FACT=3}
  }
  if(TipoeCF==44){
    IND_FACT=4
  }

if(element.impuesto==null || element.impuesto!=null && !element.impuesto.hasOwnProperty("tasa")){ 
 IND_FACT=4
}



   var BienoServicio=element.productos.servicio==true?2:1
  var DESCUENTO=""
  if(element.valordescuento>0){
    DESCUENTO=`
    <DescuentoMonto>${element.valordescuento}</DescuentoMonto> 
    <TablaSubDescuento>
      <SubDescuento>
        <TipoSubDescuento>$</TipoSubDescuento> 
        <MontoSubDescuento>${element.valordescuento}</MontoSubDescuento> 
      </SubDescuento>
    </TablaSubDescuento>
   `
  }
  var ITEM=`
   <Item>
      <NumeroLinea>${NumeroLinea++}</NumeroLinea>
	    <IndicadorFacturacion>${IND_FACT}</IndicadorFacturacion>
      <NombreItem>${element.descripcion.trim()}</NombreItem>
      <IndicadorBienoServicio>${BienoServicio}</IndicadorBienoServicio>
      <CantidadItem>${element.cantidad}</CantidadItem>
      <PrecioUnitarioItem>${element.precio}</PrecioUnitarioItem>
      ${DESCUENTO}
      <MontoItem>${(this.RedondeoValorCantRed((element.cantidad*element.precio),2))}</MontoItem> 
    </Item>`
    VARDET+=ITEM
  }));

  

  //       <UnidadReferencia>43</UnidadReferencia> 
  //       <CantidadReferencia>${element.cantidad}</CantidadReferencia>
return VARDET;

},


getDetallesItemsDevolucion(FACTURA){
  var TipoeCF= FACTURA.tipocomprobante.hasOwnProperty('tipoEcf') && FACTURA.tipocomprobante.tipoEcf!=null?FACTURA.tipocomprobante.tipoEcf:'';
   // <IndicadorFacturacion>0</IndicadorFacturacion>
   //0: No Facturable 
  //1: ITBIS 1 (18%)  
  //2: ITBIS 2 (16%) 
  //3: ITBIS 3 (0%) 
  //4: Exento (E) 
  var ListDet=FACTURA.ListDet
  var VARDET=""
  var NumeroLinea=1


  // ListDet.forEach(element => { });
  Promise.all(ListDet.map(async (element) => {
    var IND_FACT=0

  //var MONTO_IMPUESTO=0;
  var MONTO_IMPUESTO=element.valorimpuesto;
  if(element.valorimpuesto>0 &&element.impuesto!=null && element.impuesto.hasOwnProperty("tasa")){
    if(element.impuesto.tasa==18){IND_FACT=1}
    if(element.impuesto.tasa==16){IND_FACT=2}
    if(element.impuesto.tasa==0){IND_FACT=3}
  }
  if(TipoeCF==44){
    IND_FACT=4
  }

if(element.impuesto==null || element.impuesto!=null && !element.impuesto.hasOwnProperty("tasa")){ 
 IND_FACT=4
}

   var BienoServicio=element.productos.servicio==true?2:1
  var DESCUENTO=""
  if(element.valordescuento>0){
    DESCUENTO=`
    <DescuentoMonto>${element.valordescuento}</DescuentoMonto> 
    <TablaSubDescuento>
      <SubDescuento>
        <TipoSubDescuento>$</TipoSubDescuento> 
        <MontoSubDescuento>${element.valordescuento}</MontoSubDescuento> 
      </SubDescuento>
    </TablaSubDescuento>
   `
  }
  var ITEM=`
   <Item>
      <NumeroLinea>${NumeroLinea++}</NumeroLinea>
	    <IndicadorFacturacion>${IND_FACT}</IndicadorFacturacion>
      <NombreItem>${element.descripcion.trim()}</NombreItem>
      <IndicadorBienoServicio>${BienoServicio}</IndicadorBienoServicio>
      <CantidadItem>${element.cantidad}</CantidadItem>
      <PrecioUnitarioItem>${element.precio}</PrecioUnitarioItem>
      ${DESCUENTO}
      <MontoItem>${(this.RedondeoValorCantRed((element.cantidad*element.precio),2))}</MontoItem> 
    </Item>`
    VARDET+=ITEM
  }));

  

  //       <UnidadReferencia>43</UnidadReferencia> 
  //       <CantidadReferencia>${element.cantidad}</CantidadReferencia>
return VARDET;

},


//Recepción de resumen factura de consumo e-CF
FacturaXMLrFCE(FACTURA){

var eNCF=FACTURA.ncf.trim()
var MontoTotal= FACTURA.valor;
var TotalItbis= FACTURA.valorimpuesto;
FACTURA.ListDet=FACTURA.facturasventaDetalleList
var CodigoSeguridadeCF="130485"
// a) Código Tipo: 1: Contado 2: Crédito 3: Gratuito  
var TipoPago=1
if(FACTURA.cxc>0){TipoPago=2}
var TipoeCF= FACTURA.tipocomprobante.hasOwnProperty('tipoEcf') && FACTURA.tipocomprobante.tipoEcf!=null?FACTURA.tipocomprobante.tipoEcf:'';
var FAC_STRING=`
<?xml version="1.0" encoding="utf-8"?>
<RFCE>
  <Encabezado>
    <Version>1.0</Version>
    <IdDoc>
      <TipoeCF>${TipoeCF}</TipoeCF>
      <eNCF>${eNCF}</eNCF>${this.getTipoIngresos(TipoeCF)}
      <TipoPago>${TipoPago}</TipoPago>
      <TablaFormasPago>${this.getFormaDePagoFACTELECT(FACTURA)}
      </TablaFormasPago>
    </IdDoc> ${this.getEmisorFactEletroRFCE(FACTURA)} ${this.getCompradorFactEletroECF_RFCE(FACTURA)}
    ${this.getTotalFactEletroRFCE(FACTURA)}
    <CodigoSeguridadeCF>${CodigoSeguridadeCF}</CodigoSeguridadeCF>
  </Encabezado>
</RFCE>`
// ${this.getTotalFactEletroECF(FACTURA)}

  return FAC_STRING.trim()
},



//Recepción de e‐CF: 
FacturaXMLeCF(FACTURA){ 
 //  abajo de <TipoPago>   , <FechaLimitePago>10-10-2024</FechaLimitePago> 
// 	 abajo de <IndicadorMontoGravado>  <IndicadorServicioTodoIncluido>1</IndicadorServicioTodoIncluido>
// console.log( new Date().toLocaleDateString("en-CA"))
// console.log(new Date())
// console.log(this.getHoraActual())

var eNCF=FACTURA.ncf.trim()
var MontoTotal= FACTURA.valor;
var fechaVencimiento=this.FormatoFecha(FACTURA.ncfVencimientonuevaFecha)
// a) Código Tipo: 1: Contado 2: Crédito 3: Gratuito  
var TipoPago=1
var FechaLimitePago=''
if(FACTURA.cxc>0){
  TipoPago=2
  var fechiLimit=new Date()
  var CantF= FACTURA.diascredito!=null? FACTURA.diascredito: 30
  fechiLimit.setDate(fechiLimit.getDate() + CantF);
  fechiLimit =new Date(fechiLimit)
  FechaLimitePago=`
  <FechaLimitePago>${this.FormatoFecha(fechiLimit)}</FechaLimitePago>
  `
}
var TipoeCF= FACTURA.tipocomprobante.hasOwnProperty('tipoEcf') && FACTURA.tipocomprobante.tipoEcf!=null?FACTURA.tipocomprobante.tipoEcf:'';
var IncluirItbisGeneral =this.$store.getters.GetConfiguracionGeneral.configPv.impuestoincluido;
FACTURA.ListDet=FACTURA.facturasventaDetalleList
// 0: no tienen ITBIS incluido. / 1: se encuentran con ITBIS incluido.
var IndicadorMontoGravado = IncluirItbisGeneral==true?1:0
//<FechaLimitePago> 
//<FechaLimitePago>${this.FormatoFecha(this.fechaNueva())}</FechaLimitePago>
/* <IndicadorEnvioDiferido>1</IndicadorEnvioDiferido> */
// <TotalPaginas>1</TotalPaginas>
var FAC_STRING=`
<?xml version="1.0" encoding="utf-8"?>
<ECF>
  <Encabezado>
    <Version>1.0</Version>
    <IdDoc>
      <TipoeCF>${TipoeCF}</TipoeCF>   
      <eNCF>${eNCF}</eNCF>${this.getFechaVencimientoSecuencia(TipoeCF,fechaVencimiento)} ${this.getIndicadorMontoGravado(TipoeCF,IndicadorMontoGravado)} ${this.getTipoIngresos(TipoeCF)}
      <TipoPago>${TipoPago}</TipoPago>${FechaLimitePago}
		    <TablaFormasPago>${this.getFormaDePagoFACTELECT(FACTURA)}
        </TablaFormasPago>
    </IdDoc> ${this.getEmisorFactEletroECF(FACTURA)} ${this.getCompradorFactEletroECF_RFCE(FACTURA)}
  	${this.getTotalFactEletroECF(FACTURA)}
  </Encabezado>
  <DetallesItems>${this.getDetallesItems(FACTURA)}
  </DetallesItems>
  
  <FechaHoraFirma>${this.FormatoFecha(this.fechaNueva())} ${this.getHoraActual().substr(0,5)}:00</FechaHoraFirma>
</ECF>`
//13-09-2024 17:11:44

/* <Paginacion>
    <Pagina>
      <PaginaNo>1</PaginaNo>
      <NoLineaDesde>1</NoLineaDesde>
      <NoLineaHasta>1</NoLineaHasta>
      <SubtotalMontoGravadoPagina>0.00</SubtotalMontoGravadoPagina>
      <SubtotalExentoPagina>0.00</SubtotalExentoPagina>
      <SubtotalItbisPagina>0.00</SubtotalItbisPagina>
	    <MontoSubtotalPagina>${MontoTotal}</MontoSubtotalPagina>
      <SubtotalMontoNoFacturablePagina>${MontoTotal}</SubtotalMontoNoFacturablePagina>
    </Pagina>
  </Paginacion> */

return FAC_STRING.trim();


},  

//Recepción de e‐CF: 
DevolucionXMLeCF(DEV){ 
var  FACTURA=JSON.parse(JSON.stringify(DEV.facturasventa))
var eNCF=DEV.ncf.trim()
var MontoTotal= DEV.valor;
// var fechaVencimiento=this.FormatoFecha(FACTURA.ncfVencimientonuevaFecha)
// a) Código Tipo: 1: Contado 2: Crédito 3: Gratuito  
var TipoPago=1
var FechaLimitePago=''
if(FACTURA.cxc>0){
  TipoPago=2
  var fechiLimit=new Date()
  var CantF= FACTURA.diascredito!=null? FACTURA.diascredito: 30
  fechiLimit.setDate(fechiLimit.getDate() + CantF);
  fechiLimit =new Date(fechiLimit)
  FechaLimitePago=`
  <FechaLimitePago>${this.FormatoFecha(fechiLimit)}</FechaLimitePago>
  `
}
//var TipoeCF= FACTURA.tipocomprobante.hasOwnProperty('tipoEcf') && FACTURA.tipocomprobante.tipoEcf!=null?FACTURA.tipocomprobante.tipoEcf:'';
var TipoeCF= eNCF.substr(1,2)

var IncluirItbisGeneral =this.$store.getters.GetConfiguracionGeneral.configPv.impuestoincluido;
// 0: no tienen ITBIS incluido. / 1: se encuentran con ITBIS incluido.
var IndicadorMontoGravado = IncluirItbisGeneral==true?1:0
var ahora=this.fechaNueva()
var DATA_FAC_DEV={
  ncfFac:FACTURA.ncf.trim(),
  sucursal:FACTURA.sucursal,
  nuevaFecha:DEV.nuevaFecha,
  nuevaFechaFac:FACTURA.nuevaFecha,
  valor:DEV.valor,
  valorimpuesto:DEV.valorItbis,
  tipocomprobante:{tipoEcf:TipoeCF},
  ListDet:[],
  fechAhora:this.FormatoFecha(ahora)
}

console.log('Inf--DEV-->',DATA_FAC_DEV)
console.log('Inf--FACTURA-->',FACTURA)

var LIST_DEV=[]
 Promise.all(DEV.devolucionDetalleList.map(async (element) => { 
   var ObjProRow = DEV.facturasventa.facturasventaDetalleList.filter((ee) => ee.productos.codigo == element.producto.codigo && ee.unidades.codigo == element.unidad.codigo && ee.precio == element.precio);
   ObjProRow[0].cantidad=element.cantidad
   LIST_DEV.push(ObjProRow[0])
  }));


DATA_FAC_DEV.ListDet=LIST_DEV

var FAC_STRING=`
<?xml version="1.0" encoding="utf-8"?>
<ECF>
  <Encabezado>
    <Version>1.0</Version>
    <IdDoc>
      <TipoeCF>${TipoeCF}</TipoeCF>   
      <eNCF>${eNCF}</eNCF> ${this.getIndicadorNotaCredito(ahora,FACTURA.nuevaFecha)} ${this.getIndicadorMontoGravado(TipoeCF,IndicadorMontoGravado)} ${this.getTipoIngresos(TipoeCF)}
      <TipoPago>${TipoPago}</TipoPago>
    </IdDoc> ${this.getEmisorFactEletroECF(DATA_FAC_DEV)} ${this.getCompradorFactEletroECF_RFCE(FACTURA)}
  	${this.getTotalFactEletroECF(DATA_FAC_DEV)}
  </Encabezado>
  <DetallesItems>${this.getDetallesItemsDevolucion(DATA_FAC_DEV)}
  </DetallesItems>${this.footerDevolucion(DATA_FAC_DEV)}
  <FechaHoraFirma>${this.FormatoFecha(ahora)} ${this.getHoraActual().substr(0,5)}:00</FechaHoraFirma>
</ECF>`
//13-09-2024 17:11:44

console.log('INF-->',FAC_STRING.trim())

return FAC_STRING.trim();


},  

footerDevolucion(DATA_FAC_DEV){

//Código utilizado para indicar si el e-CF del comprobante fiscal modificado es con la finalidad de: 
/*1= a) Anulación total  
  2= b) Corrección montos  
  3= c) Corrección Texto  
  4= d) Reemplazo NCF emitido en contingencia 
  5= e) Referenciar Factura de Consumo Electrónica. 
 
  a), b) y c) solo aplican para Nota de 
  Crédito o Débito Electrónica.*/

  /*
  a) Código tipo80: 
1: Anula el NCF modificado 
2: Corrige Texto del Comprobante Fiscal modificado  
3: Corrige montos del NCF modificado 
4: Reemplazo NCF emitido en contingencia 
5: Referencia Factura Consumo Electrónica.81 
  */ 
//<RazonModificacion>Error en datos</RazonModificacion>
  var DEV_STRING=
  `<InformacionReferencia>
<NCFModificado>${DATA_FAC_DEV.ncfFac}</NCFModificado>
<FechaNCFModificado>${this.FormatoFecha(DATA_FAC_DEV.nuevaFechaFac)}</FechaNCFModificado>
<CodigoModificacion>3</CodigoModificacion>
</InformacionReferencia>
  `;

  return DEV_STRING;

},


getIndicadorMontoGravado(TipoeCF,IndicadorMontoGravado){
var IND_MON_GRAV=``;

var TIPO_ECF_ARRYS=[33,34,43,44,46,47]
if(TIPO_ECF_ARRYS.includes(TipoeCF)){
  IND_MON_GRAV=``;
}else{

  if(TipoeCF==41){
IND_MON_GRAV=`
<IndicadorMontoGravado>0</IndicadorMontoGravado>`

  }else{
IND_MON_GRAV=`
<IndicadorMontoGravado>${IndicadorMontoGravado}</IndicadorMontoGravado>`

  }
 
}

return IND_MON_GRAV;
},


getIndicadorNotaCredito(FechAhora,factnuevaFecha){

// var Ahora= new Date();
// var NEW_EXPIRA =new Date(res.data.fechaSupencion)

const fechaFact = new Date(factnuevaFecha);
const Ahora = new Date(FechAhora);
// Calcular la diferencia en milisegundos
const diferenciaMs = Ahora - fechaFact;
// Convertir a días
const diasPasados = Math.floor(diferenciaMs / (1000 * 60 * 60 * 24));

//a) Valor 0 si fecha de emisión del e-CF afectado es ≤ 30 días calendario.  
//b) Valor 1 si fecha de emisión del e-CF afectado es > 30 días calendario. 

var IND_NOT_CRE=``;
var DAT_NOT_CRE= diasPasados>30?1:0;
IND_NOT_CRE=`
<IndicadorNotaCredito>${DAT_NOT_CRE}</IndicadorNotaCredito>`
return IND_NOT_CRE;
},





getFechaVencimientoSecuencia(TipoeCF,fechaVencimiento){
var FEC_VEN_SEC=``;


if(TipoeCF===32 || TipoeCF===34){
}else{
  FEC_VEN_SEC=`
<FechaVencimientoSecuencia>${fechaVencimiento}</FechaVencimientoSecuencia>`
}

return FEC_VEN_SEC;
},


//Recepción de resumen factura de consumo e-CF
AnularFacturaXML(FACTURA){

var eNCF=FACTURA.ncf.trim()
var CodigoSeguridadeCF="130485"
var TipoeCF= FACTURA.tipocomprobante.hasOwnProperty('tipoEcf') && FACTURA.tipocomprobante.tipoEcf!=null?FACTURA.tipocomprobante.tipoEcf:'';


// var RNCEmisor = this.$store.getters.GetConfiguracionGeneral.config.rnc.trim().replace("-", "").replace(/-/g,'');
var RNCEmisor =FACTURA.sucursal.rnc.trim().replace("-", "").replace(/-/g,'');
var TipoeCF= FACTURA.tipocomprobante.hasOwnProperty('tipoEcf') && FACTURA.tipocomprobante.tipoEcf!=null?FACTURA.tipocomprobante.tipoEcf:'';

var FAC_STRING=`
<?xml version="1.0" encoding="utf-8"?>
<ANECF>
  <Encabezado>
    <Version>1.0</Version>
    <RncEmisor>${RNCEmisor}</RncEmisor>
    <CantidadeNCFAnulados>1</CantidadeNCFAnulados>
    <FechaHoraAnulacioneNCF>${this.FormatoFecha(this.fechaNueva())} ${this.getHoraActual().substr(0,5)}:00</FechaHoraAnulacioneNCF>
  </Encabezado>
  <DetalleAnulacion> 
    <Anulacion>
     <NoLinea>1</NoLinea>
     <TipoeCF>${TipoeCF}</TipoeCF>
      <Secuencias> 
       <SecuenciaeNCFDesde>${eNCF}</SecuenciaeNCFDesde>
       <SecuenciaeNCFHasta>${eNCF}</SecuenciaeNCFHasta>
      </Secuencias>
      <CantidadeNCFAnulados>1<CantidadeNCFAnulados>
    </Anulacion>
  </DetalleAnulacion>
</ANECF>`
  return FAC_STRING.trim()
},



async procesarTokenXML_RFCE(FACTURA){
  /*var params = new Date("2024-09-18T12:26:23Z").toLocaleDateString("en-CA")
  var params1 = new Date("2024-09-18T12:26:23Z").toISOString();
  var params2 =new Date("2024-09-18T12:26:23Z").toLocaleDateString("en-CA");
  var pparams =new Date("2024-09-18T12:26:23Z")*/

// eje
 /*var Ahora= new Date("2025-02-10T20:13:41Z")
  var expedido= "2025-02-10T19:28:41Z"
 var expira= "2025-02-10T20:28:41Z"*/
 var Ahora= new Date()
  var expedido= FACTURA.sucursal.expedido
  var expira= FACTURA.sucursal.expira
  var token= FACTURA.sucursal.token

//  console.log("--------------")
//   console.log(".Ahora->",Ahora)
//   console.log(".expedido->",new Date(expedido)); //
//   console.log(".expira->",new Date(expira))
//   console.log("--------------")

   var NEW_EXPIRA =new Date(expira)
   NEW_EXPIRA.setMinutes(NEW_EXPIRA.getMinutes() - 8);
   NEW_EXPIRA=new Date(NEW_EXPIRA)
  //  if(this.semilla!=null)
  if(expira!=null){
    var SEMILLA={
      expedido: expedido,
      expira: expira,
      token: token
    }
    var Ahora= new Date();
    // var expira= "2025-02-10T20:28:41Z"
    var NEW_EXPIRA =new Date(expira)
    NEW_EXPIRA.setMinutes(NEW_EXPIRA.getMinutes() - 8);
    NEW_EXPIRA=new Date(NEW_EXPIRA)
    if(Ahora>=NEW_EXPIRA){
      //console.log('GENERAR TOQUEN NEW')
      const resObjToken =  await this.getSemillaValidaGetToken(FACTURA);
      const resPROFAC_RFCE =  await this.procesarFacturaXML_RFCE(FACTURA,resObjToken.token);
      //console.log('NEW TOKEN GENERADO-->',resObjToken)
      return resPROFAC_RFCE;
  }else{
    // console.log('TOKEN EXISTENTE-->',this.semilla)
    // const resPROFAC_RFCE =  await this.procesarFacturaXML_RFCE(FACTURA,this.semilla.token);
    const resPROFAC_RFCE =  await this.procesarFacturaXML_RFCE(FACTURA,SEMILLA);
     return resPROFAC_RFCE;
  }

  }else{
    const resObjToken =  await this.getSemillaValidaGetToken(FACTURA);
    const resPROFAC_RFCE =  await this.procesarFacturaXML_RFCE(FACTURA,resObjToken.token);
    return resPROFAC_RFCE;
  }

},


async procesarFacturaXML_RFCE(FACT,resObjToken){

  var ObjDirecSucursal={
nombreCertDGI:FACT.caja.sucursal.nombreArchivoDgi,
passCertDGI:FACT.caja.sucursal.passCertDgi,
sucursalRnc:FACT.caja.sucursal.rnc.trim().replace("-", "").replace(/-/g,'')
 }
  var AMBIENTE=FACT.sucursal.ambienteDgi!=null?FACT.sucursal.ambienteDgi:"testecf";
  const resXMLConvert = await this.FacturaXMLrFCE(FACT);
  const resXMLSellada = await this.firmarArchivoXML(resXMLConvert,ObjDirecSucursal);
  const reader = new FileReader();
  var xmlString=''; 
  var _this = this;

  //var RNCEmisor = this.$store.getters.GetConfiguracionGeneral.config.rnc.trim().replace("-", "").replace(/-/g,'');
  var RNCEmisor =FACT.sucursal.rnc.trim().replace("-", "").replace(/-/g,'');
  var NombreXml=RNCEmisor.trim()+""+FACT.ncf.trim();
  var fechafirmadgii=`${this.FormatoFecha(this.fechaNueva())} ${this.getHoraActual().substr(0,5)}:00`
  var cedularncncf=FACT.cedularncncf.trim().replace("-", "").replace(/-/g,'')
  const signatureValue = await this.getSignatureValue(resXMLSellada.split("<SignatureValue>")[1].substr(0,6));


  var ObjCOMPLETO={};
  ObjCOMPLETO.codSeguridadDgi=FACT.sucursal.codSeguridadDgi.trim()
  // E320000031086--> https://fc.dgii.gov.do/testecf/consultatimbrefc?rncemisor=130412881&encf=E320000031086&montototal=727.12&codigoseguridad=130485

  // `https://fc.dgii.gov.do/${AMBIENTE}/consultatimbrefc?rncemisor=${RNCEmisor}&encf=${FACT.ncf.trim()}&montototal=${FACT.valor}&codigoseguridad=${ObjCOMPLETO.codSeguridadDgi}`
  var VAR_FECA_DGII=fechafirmadgii.trim().replaceAll(' ', '%20')
  ObjCOMPLETO.fechafirmadgii=fechafirmadgii.trim()
  ObjCOMPLETO.qrdgii=`https://fc.dgii.gov.do/${AMBIENTE}/consultatimbrefc?rncemisor=${RNCEmisor}&encf=${FACT.ncf.trim()}&montototal=${FACT.valor}&codigoseguridad=${ObjCOMPLETO.codSeguridadDgi}`
  ObjCOMPLETO.signatureValue=resXMLSellada.split("<SignatureValue>")[1].substr(0,6)
  ObjCOMPLETO.ObjToken=resObjToken;
  ObjCOMPLETO.xmlSellada=resXMLSellada
  ObjCOMPLETO.nombreXml=NombreXml
  ObjCOMPLETO.ambiente=AMBIENTE

  const objtrackId =  await this.envioXmlSelladoENDPOINT(ObjCOMPLETO)
  console.log('objtrackId-->',objtrackId)
 this.descargarXml(resXMLSellada,NombreXml)
 ObjCOMPLETO.objtrackId=objtrackId
 return ObjCOMPLETO


  //  https://fc.dgii.gov.do/{ambiente}/recepcionfc/api/recepcion/ecf
// COMiENSO AQUI
  //   return  new Promise((resolve, reject) => {  
//     //var AMBIENTE='testecf'
//     // var AMBIENTE= this.ambiente
//     var AMBIENTE=FACT.sucursal.ambienteDgi!=null?FACT.sucursal.ambienteDgi:"testecf";
//     let texto = resXMLSellada
//   let blob = new Blob([texto], { type: 'application/xml' });
//   const formData = new FormData();  
//   formData.append('xml', blob, `${NombreXml}.xml`);      
//         var headHEAD={} ;
//          headHEAD["Content-Type"] = "multipart/form-data"
//          headHEAD["accept"]= "application/json"
//          headHEAD["Authorization"]= "Bearer "+TOKEN
//         headHEAD["Accept-Encoding"] = "gzip, deflate, br, zstd"
//         headHEAD["Access-Control-Allow-Origin"] = "*"
//         headHEAD["Access-Control-Allow-Methods"] = "GET,PUT,POST,DELETE,PATCH,OPTIONS"
//         headHEAD["Access-Control-Allow-Headers"] = "Origin, X-Requested-With, Content-Type, Accept, Authorization"
//         headHEAD["Access-Control-Allow-Origin"] = "https://localhost:8080"


// // 'Access-Control-Allow-Origin' : '*',
// //   'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',


//   /*headers.append('Content-Type', 'application/json');
//   headers.append('Accept', 'application/json');

//   headers.append('Access-Control-Allow-Origin', 'http://localhost:3000');
//   headers.append('Access-Control-Allow-Credentials', 'true');

//   headers.append('GET', 'POST', 'OPTIONS');*/


//         // var url2=`https://ecf.dgii.gov.do/${AMBIENTE}/autenticacion/api/Autenticacion/ValidarSemilla`
//         var url2=`https://fc.dgii.gov.do/${AMBIENTE}/recepcionfc/api/recepcion/ecf`
//           this.$axios.post(url2,formData,{ headers: headHEAD })
//         .then((resss) => {
//           console.log('resss-->',resss.data)
//           resolve(resss.data)
//          })
//          .catch((error) => {
//           this.alerta("DATA XML NO VALIDADO", "error")
//           resolve(null)
//         });

//   });
// FIn AQUI







/*const resXMLConvert = this.FacturaXMLeCF(ObjFAC);
const resXMLSellada = await this.firmarArchivoXML(resXMLConvert);
const reader = new FileReader();
var xmlString=''; 
var _this = this;*/

},


async procesarTokenXML_ECF(FACTURA){
 /*var params = new Date("2024-09-18T12:26:23Z").toLocaleDateString("en-CA")
  var params1 = new Date("2024-09-18T12:26:23Z").toISOString();
  var params2 =new Date("2024-09-18T12:26:23Z").toLocaleDateString("en-CA");
  var pparams =new Date("2024-09-18T12:26:23Z")*/

// eje

/*var Ahora= new Date("2025-02-10T20:13:41Z")
  var expedido= "2025-02-10T19:28:41Z"
 var expira= "2025-02-10T20:28:41Z"*/

 var Ahora= new Date()
  var expedido= FACTURA.sucursal.expedido
  var expira= FACTURA.sucursal.expira
  var token= FACTURA.sucursal.token
  /*FACTURA.sucursal.nombreArchivoDgi: "13048546_identity"
  FACTURA.sucursal.passCertDgi:"pore0184"
  FACTURA.sucursal.rnc: "101-07139-7"
  FACTURA.sucursal.ambienteDgi
*/

   var NEW_EXPIRA =new Date(expira)
   NEW_EXPIRA.setMinutes(NEW_EXPIRA.getMinutes() - 8);
   NEW_EXPIRA=new Date(NEW_EXPIRA)
  // if(this.semilla!=null) 
  if(expira!=null){
    var SEMILLA={
      expedido: expedido,
      expira: expira,
      token: token
    }
    var Ahora= new Date();
   // var expira= "2025-02-10T20:28:41Z"
    var NEW_EXPIRA =new Date(expira)
    NEW_EXPIRA.setMinutes(NEW_EXPIRA.getMinutes() - 8);
    NEW_EXPIRA=new Date(NEW_EXPIRA)
    // console.log(`Ahora>=NEW_EXPIRA(${Ahora>=NEW_EXPIRA})--> ${Ahora} ---> ${NEW_EXPIRA}`)
    if(Ahora>=NEW_EXPIRA){
      const resObjToken =  await this.getSemillaValidaGetToken(FACTURA);
      const resPROFAC_ECF =  await this.procesarFacturaXML_ECF(FACTURA,resObjToken);
      // console.log('resPROFAC_ECF-->',resPROFAC_ECF)
      //console.log('NEW TOKEN GENERADO-->',resObjToken)
      return resPROFAC_ECF;
  }else{
    // console.log('TOKEN EXISTENTE-->',this.semilla)
    // const resPROFAC_ECF =  await this.procesarFacturaXML_ECF(FACTURA,this.semilla);
   const resPROFAC_ECF =  await this.procesarFacturaXML_ECF(FACTURA,SEMILLA);
    // console.log('resPROFAC_ECF-->',resPROFAC_ECF)
     return resPROFAC_ECF;
  }

  }else{
    const resObjToken =  await this.getSemillaValidaGetToken(FACTURA);
    const resPROFAC_ECF =  await this.procesarFacturaXML_ECF(FACTURA,resObjToken);
    // console.log('resPROFAC_ECF-->',resPROFAC_ECF)
    return resPROFAC_ECF;
  }


},


async procesarFacturaXML_ECF(FACT,resObjToken){
 var ObjDirecSucursal={
nombreCertDGI:FACT.caja.sucursal.nombreArchivoDgi,
passCertDGI:FACT.caja.sucursal.passCertDgi,
sucursalRnc:FACT.caja.sucursal.rnc.trim().replace("-", "").replace(/-/g,'')
 }
 // var AMBIENTE= this.ambiente
 var AMBIENTE=FACT.sucursal.ambienteDgi!=null?FACT.sucursal.ambienteDgi:"testecf";
const resXMLConvert = await this.FacturaXMLeCF(FACT);
  const resXMLSellada = await this.firmarArchivoXML(resXMLConvert,ObjDirecSucursal);
  const reader = new FileReader();
  var xmlString=''; 
  var _this = this;
  //var RNCEmisor = this.$store.getters.GetConfiguracionGeneral.config.rnc.trim().replace("-", "").replace(/-/g,'');
  var RNCEmisor =FACT.sucursal.rnc.trim().replace("-", "").replace(/-/g,'');
  var NombreXml=RNCEmisor.trim()+""+FACT.ncf.trim();
  var fechafirmadgii=`${this.FormatoFecha(this.fechaNueva())} ${this.getHoraActual().substr(0,5)}:00`
  var cedularncncf=FACT.cedularncncf.trim().replace("-", "").replace(/-/g,'')
  const signatureValue = await this.getSignatureValue(resXMLSellada.split("<SignatureValue>")[1].substr(0,6));

var ObjCOMPLETO={};
//  ObjCOMPLETO.fechafirmadgii=fechafirmadgii.trim().replaceAll(' ', '%20')
 var VAR_FECA_DGII=fechafirmadgii.trim().replaceAll(' ', '%20')
  ObjCOMPLETO.fechafirmadgii=fechafirmadgii.trim()
//  ObjCOMPLETO.qrdgii=` https://fc.dgii.gov.do/testecf/consultatimbrefc?rncemisor=${RNCEmisor}&encf=${eNCF}&montototal=${MontoTotal}&codigoseguridad=130485`;
 ObjCOMPLETO.qrdgii=`https://ecf.dgii.gov.do/${AMBIENTE}/consultatimbre?rncemisor=${RNCEmisor}&rnccomprador=${cedularncncf}&encf=${FACT.ncf.trim()}&fechaemision=${this.FormatoFecha(FACT.nuevaFecha)}&montototal=${FACT.valor}&fechafirma=${VAR_FECA_DGII}&codigoseguridad=${signatureValue}`;
 ObjCOMPLETO.signatureValue=resXMLSellada.split("<SignatureValue>")[1].substr(0,6)
 ObjCOMPLETO.ObjToken=resObjToken;
 ObjCOMPLETO.trackId="";
 ObjCOMPLETO.xmlSellada=resXMLSellada
 ObjCOMPLETO.nombreXml=NombreXml
 ObjCOMPLETO.ambiente=AMBIENTE

 const objtrackId =  await this.envioXmlSelladoENDPOINT(ObjCOMPLETO)
 this.descargarXml(resXMLSellada,NombreXml)
 ObjCOMPLETO.objtrackId=objtrackId
 return ObjCOMPLETO


//  https://fc.dgii.gov.do/{ambiente}/recepcionfc/api/recepcion/ecf
  return  new Promise((resolve, reject) => {  
    //var AMBIENTE='testecf'
   
    let texto = resXMLSellada
  let blob = new Blob([texto], { type: 'application/xml' });
  const formData = new FormData();  
  formData.append('xml', blob, `${NombreXml}.xml`);      
        var headHEAD={} ;
         headHEAD["Content-Type"] = "multipart/form-data"
         headHEAD["accept"]= "application/json"
         headHEAD["Authorization"]= "Bearer "+resObjToken.token
        headHEAD["Accept-Encoding"] = "gzip, deflate, br, zstd"
        headHEAD["Access-Control-Allow-Origin"] = "*"
        headHEAD["Access-Control-Allow-Methods"] = "GET,PUT,POST,DELETE,PATCH,OPTIONS"
        headHEAD["Access-Control-Allow-Headers"] = "Origin, X-Requested-With, Content-Type, Accept, Authorization"
        headHEAD["Access-Control-Allow-Origin"] = "https://localhost:8080"


// 'Access-Control-Allow-Origin' : '*',
//   'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
  /*headers.append('Content-Type', 'application/json');
  headers.append('Accept', 'application/json');
  headers.append('Access-Control-Allow-Origin', 'http://localhost:3000');
  headers.append('Access-Control-Allow-Credentials', 'true');
  headers.append('GET', 'POST', 'OPTIONS');*/
        // var url2=`https://ecf.dgii.gov.do/${AMBIENTE}/autenticacion/api/Autenticacion/ValidarSemilla`
        // var url2=`https://fc.dgii.gov.do/${AMBIENTE}/recepcionfc/api/recepcion/ecf`
        
        var url2=`https://ecf.dgii.gov.do/${ambiente}/recepcion/api/facturaselectronicas`
          this.$axios.post(url2,formData,{ headers: headHEAD })
        .then((resss) => {
          console.log('resss-->',resss.data)
          resolve(resss.data)
         })
         .catch((error) => {
          this.alerta("DATA XML NO VALIDADO", "error")
          resolve(null)
        });

  });


},

// -*------------* DEVOLUCION *------------


async procesarTokenXML_ECF_DEV(DEV){

  var FACTURA =JSON.parse(JSON.stringify(DEV.facturasventa))

 var Ahora= new Date()
  var expedido= FACTURA.sucursal.expedido
  var expira= FACTURA.sucursal.expira
  var token= FACTURA.sucursal.token


   var NEW_EXPIRA =new Date(expira)
   NEW_EXPIRA.setMinutes(NEW_EXPIRA.getMinutes() - 8);
   NEW_EXPIRA=new Date(NEW_EXPIRA)
  // if(this.semilla!=null) 
  if(expira!=null){
    var SEMILLA={
      expedido: expedido,
      expira: expira,
      token: token
    }
    var Ahora= new Date();
    var NEW_EXPIRA =new Date(expira)
    NEW_EXPIRA.setMinutes(NEW_EXPIRA.getMinutes() - 8);
    NEW_EXPIRA=new Date(NEW_EXPIRA)
    if(Ahora>=NEW_EXPIRA){
      const resObjToken =  await this.getSemillaValidaGetToken(FACTURA);
      const resPROFAC_ECF =  await this.procesarDevolucionXML_ECF(DEV,resObjToken);
      return resPROFAC_ECF;
  }else{

   const resPROFAC_ECF =  await this.procesarDevolucionXML_ECF(DEV,SEMILLA);
    return resPROFAC_ECF;
  }

  }else{
    const resObjToken =  await this.getSemillaValidaGetToken(FACTURA);
    const resPROFAC_ECF =  await this.procesarDevolucionXML_ECF(DEV,resObjToken);
    return resPROFAC_ECF;
  }


},


async procesarDevolucionXML_ECF(DEV,resObjToken){
   var FACT =JSON.parse(JSON.stringify(DEV.facturasventa))
 var ObjDirecSucursal={
nombreCertDGI:FACT.caja.sucursal.nombreArchivoDgi,
passCertDGI:FACT.caja.sucursal.passCertDgi,
sucursalRnc:FACT.caja.sucursal.rnc.trim().replace("-", "").replace(/-/g,'')
 }
 // var AMBIENTE= this.ambiente
 var AMBIENTE=FACT.sucursal.ambienteDgi!=null?FACT.sucursal.ambienteDgi:"testecf";
const resXMLConvert = await this.DevolucionXMLeCF(DEV);
  const resXMLSellada = await this.firmarArchivoXML(resXMLConvert,ObjDirecSucursal);
  const reader = new FileReader();
  var xmlString=''; 
  var _this = this;
  //var RNCEmisor = this.$store.getters.GetConfiguracionGeneral.config.rnc.trim().replace("-", "").replace(/-/g,'');
  var RNCEmisor =FACT.sucursal.rnc.trim().replace("-", "").replace(/-/g,'');
  var NombreXml=RNCEmisor.trim()+""+DEV.ncf.trim();
  var fechafirmadgii=`${this.FormatoFecha(this.fechaNueva())} ${this.getHoraActual().substr(0,5)}:00`
  var cedularncncf=FACT.cedularncncf.trim().replace("-", "").replace(/-/g,'')
  const signatureValue = await this.getSignatureValue(resXMLSellada.split("<SignatureValue>")[1].substr(0,6));

var ObjCOMPLETO={};
//  ObjCOMPLETO.fechafirmadgii=fechafirmadgii.trim().replaceAll(' ', '%20')
 var VAR_FECA_DGII=fechafirmadgii.trim().replaceAll(' ', '%20')
  ObjCOMPLETO.fechafirmadgii=fechafirmadgii.trim()
//  ObjCOMPLETO.qrdgii=` https://fc.dgii.gov.do/testecf/consultatimbrefc?rncemisor=${RNCEmisor}&encf=${eNCF}&montototal=${MontoTotal}&codigoseguridad=130485`;
 ObjCOMPLETO.qrdgii=`https://ecf.dgii.gov.do/${AMBIENTE}/consultatimbre?rncemisor=${RNCEmisor}&rnccomprador=${cedularncncf}&encf=${DEV.ncf.trim()}&fechaemision=${this.FormatoFecha(DEV.nuevaFecha)}&montototal=${DEV.valor}&fechafirma=${VAR_FECA_DGII}&codigoseguridad=${signatureValue}`;
 ObjCOMPLETO.signatureValue=resXMLSellada.split("<SignatureValue>")[1].substr(0,6)
 ObjCOMPLETO.ObjToken=resObjToken;
 ObjCOMPLETO.trackId="";
 ObjCOMPLETO.xmlSellada=resXMLSellada
 ObjCOMPLETO.nombreXml=NombreXml
 ObjCOMPLETO.ambiente=AMBIENTE

 const objtrackId =  await this.envioXmlSelladoENDPOINT(ObjCOMPLETO)
 this.descargarXml(resXMLSellada,NombreXml)
 ObjCOMPLETO.objtrackId=objtrackId
 return ObjCOMPLETO

},



// -*------------* FIN DEVOLUCION *------------




//Recepción de e‐CF: 
getSignatureValue(SIGN){ 
//.trim().replaceAll(' ', '%20')
var SIGN_VALUE=SIGN.trim().replaceAll('%', '%25').replaceAll(' ', '%20').replaceAll('!', '%21').replaceAll('#', '%23').replaceAll('$', '%24').replaceAll('&', '%26').replaceAll("'", '%27').replaceAll('(', '%28').replaceAll(')', '%29').replaceAll('*', '%2A').replaceAll('+', '%2B').replaceAll(',', '%2C').replaceAll('/', '%2F').replaceAll(':', '%3A').replaceAll(';', '%3B');
SIGN_VALUE=SIGN_VALUE.replaceAll('=', '%3D').replaceAll('?', '%3F').replaceAll('@', '%40').replaceAll('[', '%5B').replaceAll(']', '%5D').replaceAll('"', '%22').replaceAll('-', '%2D').replaceAll('.', '%2E').replaceAll('<', '%3C').replaceAll('>', '%3E').replaceAll('^', '%5E').replaceAll('_', '%5F').replaceAll('`', '%60').replaceAll(/\\/g, "%5C");

return SIGN_VALUE.trim();

},  



 
async envioXmlSelladoENDPOINT(ObjCOMPLETO){ 

  return  new Promise((resolve, reject) => {  
    //var AMBIENTE='testecf'
   
    let texto = ObjCOMPLETO.xmlSellada
  let blob = new Blob([texto], { type: 'application/xml' });
  const formData = new FormData();  
  formData.append('xml', blob, `${ObjCOMPLETO.nombreXml}.xml`);  
  formData.append('ambiente', ObjCOMPLETO.ambiente);
        var headHEAD={ } ;
         headHEAD["Content-Type"] = "multipart/form-data"
        //  headHEAD["accept"]= "application/json"
         headHEAD["Authorization"]= "Bearer "+ObjCOMPLETO.ObjToken.token
        
var url2=this.$hostname + this.$hName +`/dgii/recepcion/ecf`
this.$axios.post(url2,formData,{ headers: headHEAD })
        .then((resss) => {
          resolve(resss.data)
         })
         .catch((error) => {

          let msg = "";
          if (error.response) {
            msg = error.response.data
          } else if (error.request) {
            msg = error.request.data
          } else {
            msg = error.message;
          }
          resolve(msg)
        });

  });
},



async descargarXml(XML,NOMBRE_XML){
  const reader = new FileReader();

  (async () => { 
         /* xmlString= e.target.result;  
         console.log('xml-->',xmlString)*/
           let blob = new Blob([XML], { type: 'application/xml' });
           let archivo = new File([blob], `${NOMBRE_XML}.xml`, { type: 'text/xml' });  
          // let archivo = new File([blob], "xmlpruebaxml.xml", { type: 'application/xml' });  
            let dataTransfer = new DataTransfer(); 
            dataTransfer.items.add(archivo); 
            /*Descargado el archivo*/ 
            /**/const file = dataTransfer.files[0];
            const url = URL.createObjectURL(file);  
             const a = document.createElement("a"); 
              a.href = url; 
              a.download = file.name
              a.click();
              URL.revokeObjectURL(url);/**/
            })()
},


alerta(e, l) {
      if (l == "bien") {
        (this.aalert.estado = true),
          (this.aalert.color = "success"),
          (this.aalert.nombre = e);
        this.aalert.right = true
        this.aalert.top = false
        this.aalert.timeout = 3000
        // this.limpiarPuntoVentaCompleto();
      }
      if (l == "bien2") {
        (this.aalert.estado = true),
          (this.aalert.color = "success"),
          (this.aalert.nombre = e);
        this.aalert.right = true
        this.aalert.top = false
        this.aalert.timeout = 3000
        this.ejecucion = true
        this.loading(false)
        this.nuevoRegistro()

      }
      if (l == "error") {
        (this.aalert.estado = true),
          (this.aalert.color = "error"),
          (this.aalert.nombre = e);
        this.aalert.right = false
        this.aalert.top = true
        this.aalert.timeout = 120000
        this.ejecucion = true;
        this.loading(false)
      }
    },  

    loading(e) {
      EventBus.$emit("loading", e);
    },



  },
  computed: { 
    GetEjecucion() {
      this.windowSize = JSON.parse(JSON.stringify(this.$store.getters.GetwindowSize))
     },

},
};
</script>
<style lang="scss">
</style>